module.exports = __webpack_public_path__ + "img/9.b1c047dd.png";